const doc = [({"en":({"js":({"reimbursements":({"index":({"reimbursements":"Time reimbursements"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;